import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-3xl md:text-4xl font-bold mb-6" }
const _hoisted_2 = { class: "grid grid-cols-3 gap-4 mb-6 w-full max-w-md" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "text-xl md:text-2xl font-semibold mb-4"
}
const _hoisted_5 = {
  key: 1,
  class: "text-xl md:text-2xl font-semibold mb-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "flex items-center justify-center space-x-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6 animate-spin",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M4 4v7h7M20 20v-7h-7"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Restart Game")
], -1)
const _hoisted_7 = [
  _hoisted_6
]

import { ref, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameView',
  setup(__props) {

const isDarkMode = ref(false);

const toggleDarkMode = () => {
  isDarkMode.value = !isDarkMode.value;
};

function getPlayerClass(player: string): Record<string, boolean> {
  return {
    'text-cyan-600': player === 'X' && !isDarkMode.value,
    'text-blue-700': player === 'O' && !isDarkMode.value,
    'dark:text-cyan-400': player === 'X' && isDarkMode.value,
    'dark:text-red-400': player === 'O' && isDarkMode.value,
  };
}

const currentPlayer = ref('X');
const winner = ref(null);
const draw = ref(false);
const board = reactive({ cells: Array(9).fill(null) });

const winningCombinations = [
  [0, 1, 2],
  [3, 4, 5],
  [6, 7, 8],
  [0, 3, 6],
  [1, 4, 7],
  [2, 5, 8],
  [0, 4, 8],
  [2, 4, 6],
];

const checkForWinner = () => {
  let foundWinner = null;
  winningCombinations.some((combination) => {
    const [a, b, c] = combination;
    if (
      board.cells[a]
      && board.cells[a] === board.cells[b]
      && board.cells[a] === board.cells[c]
    ) {
      foundWinner = board.cells[a];
      return true;
    }
    return false;
  });
  return foundWinner;
};

const checkForDraw = () => board.cells.every((cell) => cell !== null) && winner.value === null;

const handleCellClick = (index: number) => {
  if (!board.cells[index] && !winner.value) {
    board.cells[index] = currentPlayer.value;
    const winningPlayer = checkForWinner();
    if (winningPlayer) {
      winner.value = winningPlayer;
    } else if (checkForDraw()) {
      draw.value = true;
    } else {
      currentPlayer.value = currentPlayer.value === 'X' ? 'O' : 'X';
    }
  }
};

const restartGame = () => {
  board.cells.fill(null);
  winner.value = null;
  draw.value = false;
  currentPlayer.value = 'X';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['flex flex-col items-center justify-center min-h-screen px-4','bg-gradient-to-br from-cyan-300 to-light-blue-500 dark:bg-gradient-to-br dark:from-gray-800 dark:to-black',{ 'dark': isDarkMode.value }])
  }, [
    _createElementVNode("button", {
      onClick: toggleDarkMode,
      class: "absolute top-4 right-4 bg-gray-200 dark:bg-gray-600 p-2 rounded"
    }, " Toggle Dark Mode "),
    _createElementVNode("h1", _hoisted_1, [
      _createTextVNode(" Tic-Tac-Toe: "),
      _createElementVNode("span", {
        class: _normalizeClass(['text-cyan-600', {'dark:text-cyan-400': isDarkMode.value}])
      }, _toDisplayString(currentPlayer.value) + "'s Turn", 3)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(board.cells, (cell, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: index,
          class: _normalizeClass(["aspect-square bg-white bg-opacity-60 dark:bg-gray-700 dark:bg-opacity-80 rounded-lg shadow-md text-5xl md:text-6xl font-bold transition duration-300 ease-in-out transform hover:scale-105 hover:bg-opacity-80", {
                'text-cyan-600': cell === 'X' && !isDarkMode.value,
                'text-blue-700': cell === 'O' && !isDarkMode.value,
                'dark:text-cyan-400': cell === 'X' && isDarkMode.value,
                'dark:text-red-400': cell === 'O' && isDarkMode.value
              }]),
          onClick: ($event: any) => (handleCellClick(index))
        }, _toDisplayString(cell), 11, _hoisted_3))
      }), 128))
    ]),
    (winner.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _createTextVNode(" Player "),
          _createElementVNode("span", {
            class: _normalizeClass(getPlayerClass(winner.value))
          }, _toDisplayString(winner.value), 3),
          _createTextVNode(" Wins! ")
        ]))
      : (draw.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " It's a Draw! "))
        : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: restartGame,
      class: "px-6 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full shadow-xl hover:shadow-2xl transition-all duration-500 ease-in-out transform hover:scale-110 text-lg md:text-xl font-bold dark:from-pink-500 dark:to-purple-500 dark:hover:from-pink-600 dark:hover:to-purple-600"
    }, _hoisted_7)
  ], 2))
}
}

})